import { View, Switch } from "../base";
import { useAppDispatch } from "../../redux";
import { agentEnvironmentActions } from "../../redux/reducers/agentEnvironmentSlice";

export type RegionSettingsFormData = {
  id?: string;
  agentId?: string;
  region?: string;
};

type RegionSettingsFormProps = {
  config: RegionSettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const RegionSettingsForm = ({ config, onChange }: RegionSettingsFormProps) => {
  const dispatch = useAppDispatch();

  const onChangeRegion = (value: string | null) => {
    const newRegion = value || "us-central1-a";

    // Update both local form state and persist to backend
    onChange("region")(newRegion);

    // Also update the environment directly
    if (config.id && config.agentId) {
      dispatch(
        agentEnvironmentActions.updateById({
          id: config.id,
          agentId: config.agentId,
          region: newRegion,
        }),
      );
    }
  };

  return (
    <View className="space-y-6">
      <View className="space-y-4">
        <Switch
          label="Region"
          labelClassName="!w-full"
          className="!w-full"
          tooltip="Select the region where your agent will run. Choose a region closest to your users for lower latency."
          value={config.region || "us-central1-a"}
          onChange={onChangeRegion}
          options={[
            { label: "US", value: "us-central1-a" },
            { label: "Singapore", value: "asia-southeast1-a" },
          ]}
        />
      </View>
    </View>
  );
};
